import React from 'react'
import BackgroundImage from 'gatsby-background-image'

export default function HeroSection({ title, subtitle, heroclass}) {
    return (
        <BackgroundImage 
        className={heroclass}
        
        
        >
        <h1  className="text-white text-uppercase text-center display-4">{title}</h1>
        <div>
            <h3 className="text-dark text-center text-uppercase"> {subtitle} </h3>
        </div>
        </BackgroundImage>
            
        
    )
}
